/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import * as React from "react";
import { consentStyles } from "../../styles/components/Consent/ConsentStyles";

interface IConsentComponent {
    patientName: string;
    saveConsent(hasGivenConsent: boolean): void;
}

export const ConsentComponent: React.FC<IConsentComponent> = (props: IConsentComponent) => {
    const [hasConsentBeenGiven, toogleConsent] = React.useState(false);
    return (
        <div css={consentStyles.consentContainerWrapper}>
            <div className="consent-component" css={consentStyles.container}>
                <div css={consentStyles.left}>
                    <img src="/images/consent.svg" />
                </div>
                <div css={consentStyles.right}>
                    <div css={consentStyles.consentTitle}>
                        Consent required to generate prescription
            </div>
                    <div css={consentStyles.consentSubTitle}>
                        This Consultation is booked for a family member. Please ensure that the patient
                consents to sharing of medical records & chats with {props.patientName}.
                    </div>

                    <div css={consentStyles.consentQuestion}>
                        Do You Have Patient’s Consent?
                    </div>

                    <div css={consentStyles.inputWrapper} onClick={() => toogleConsent(true)}>
                        <input type="radio" name="consent" css={consentStyles.radio} checked={hasConsentBeenGiven} />
                        <div css={consentStyles.inputTextWrapper}>
                            <div css={consentStyles.optionTitle}>Yes, Patient agrees to share records </div>
                            <div css={consentStyles.optionDescription}>All records of future consultations will also be shared with family member.</div>
                        </div>

                    </div>

                    <div css={consentStyles.inputWrapper} onClick={() => toogleConsent(false)}>
                        <input type="radio" name="consent" css={consentStyles.radio} checked={!hasConsentBeenGiven} />
                        <div css={consentStyles.inputTextWrapper}>
                            <div css={consentStyles.optionTitle}>No, Patient will book a new appointment from their account.</div>
                            <div css={consentStyles.optionDescription}> This appointment will be cancelled & booking amount will be refunded.</div>
                        </div>
                    </div>
                    <div>
                        <button css={consentStyles.button} onClick={() => props.saveConsent(hasConsentBeenGiven)}>Proceed</button>
                    </div>
                </div>

            </div>
        </div>)
}
